<div class="leading-eu-visibility-wrapper flex flex-col items-center justify-center px-4 pt-8 md:pt-12 lg:pt-0 text-center" >
  <a href="https://www.strukturnifondovi.hr/" target="_blank" >
    <img src="https://ik.imagekit.io/aglomeracijasinj/assets/eu-vidljivost.svg?updatedAt=1641824520961" alt="Europska Unija, zajedno do fondova EU" style="margin: 0; margin-top: 20px;" />
  </a>
  <p class="text-xs md:text-base" style="margin: 0; margin-top: 20px; margin-bottom: 20px;">Projekt je sufinancirala Europska unija iz Kohezijskog fonda</p>
</div>